import { css } from '@emotion/react'
import { rem } from '@groovehq/internal-design-system/lib/util/strings'

const card = theme => css`
  &.open,
  &:hover {
    background: linear-gradient(
      45deg,
      ${theme.color.secondary.info} 0%,
      ${theme.color.monochrome.white} 50%,
      ${theme.color.secondary.negative} 100%
    );
  }
`

const icon = css`
  width: ${rem(11)};
`

const actionTitle = theme => css`
  font-size: ${theme.fontSize.small};
  font-weight: ${theme.fontWeight.medium};
`

const actionButton = theme => css`
  max-height: ${rem(28)};
  font-size: ${theme.fontSize.small};
  border-radius: ${rem(26)};
`

export const styles = {
  card,
  icon,
  actionTitle,
  actionButton,
}
